/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'gear-index-icon': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M193.18 560.479v175.733l318.942 166.389 319.184-166.389V560.48L512.364 726.867 193.18 560.48zm319.184-446.737l-502.2 262.63 502.2 262.507 410.693-214.57v302.558h91.508V376.371l-502.201-262.63z" _fill="#333"/>'
  }
})
